const initialState = {
  applications: [],
  sortDir: 'ASC',
  sortKey: '',
  tenant: {}
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/home/redux/initialState.js